// MB-I18N-2A — wallet FR (extrait de LanguageContext, valeurs inchangées).
export default {
  "wallet.title": "Portefeuille",
  "wallet.available_balance": "Solde disponible",
  "wallet.recharge_notice": "Rechargez dans n'importe quel SUPERKAWA®",
  "wallet.your_card": "Votre carte",
  "wallet.show_code": "Montrez ce code au barista pour payer",
  "wallet.transactions": "Transactions",
  "wallet.prepaid_packs": "Packs prépayés",
  "wallet.no_transactions": "Aucune transaction",
  "wallet.no_packs": "Aucun pack prépayé",
  "wallet.buy_packs": "Achetez des packs en magasin",
  "wallet.coffees_left": "cafés restants",
  "wallet.copied": "Code copié !",
  "wallet.updating": "Mise à jour…",
  "wallet.loyalty_points": "Points fidélité",
  "wallet.next_reward": "Prochaine récompense",
  "wallet.points_remaining_short": "Plus que {n} pts",
  "wallet.all_unlocked_title": "Toutes les récompenses débloquées",
  "wallet.all_unlocked_subtitle": "Échangez vos points dès maintenant",
  "wallet.action_in_store": "En magasin",
  "wallet.action_online": "En ligne",
  "wallet.action_rewards": "Cadeaux",
  "wallet.my_card": "Ma Carte",
  "wallet.copy": "Copier",
  "wallet.copied_short": "Copié !",
  "wallet.show_qr": "Présentez ce code au comptoir pour payer ou recharger",
  "wallet.welcome_offer_title": "Offre de bienvenue",
  "wallet.welcome_offer_desc": "Rechargez {amount} ou plus pour recevoir 1 Boisson classique offerte !",
  "wallet.rewards_to_pick": "Récompenses à récupérer",
  "wallet.awaiting_validation": "En attente de validation en boutique",
  "wallet.awaiting_badge": "En attente",
  "wallet.available_now": "Disponibles maintenant",
  "wallet.exchangeable": "Échangeable",
  "wallet.few_more_points": "Encore quelques points",
  "wallet.history": "Historique",
  "wallet.no_transactions_long": "Aucune transaction",
  "wallet.recharge_title": "Recharger mon portefeuille",
  "wallet.recharge_show_qr": "Présentez ce code au comptoir pour recharger",
  "wallet.amount_to_recharge": "Montant à recharger",
  "wallet.recommended": "⭐ Recommandé",
  "wallet.custom_amount_note": "Montant personnalisé possible au comptoir, à partir de {amount}.",
  "wallet.rewards_dialog_title": "Récompenses fidélité",
  "wallet.my_points": "Mes points",
  "wallet.exchange": "Échanger",
  "wallet.point_ratio_msg": "Vous êtes {level} : 1 point gagné tous les {ratio} {currency} dépensés",
  "wallet.points_history_title": "Historique des points",
  "wallet.total_points": "Total points",
  "wallet.level": "Niveau",
  "wallet.no_points_history": "Aucun historique de points",
  "wallet.level_short": "Niveau {level} • 1 pt = {ratio} {currency} dépensés",
  "wallet.insufficient_points": "Points insuffisants",
  "wallet.error": "Erreur",
};
